module.exports = __webpack_public_path__ + "img/pre_dr.bd1f6b3c.gif";